module.exports = __webpack_public_path__ + "static/media/background.582ae9f8.jpg";